import PropTypes from 'prop-types'

const CommandInterface = ({ 
  renderNavigation, 
  renderProgress,
  navigationProps,
  progressProps,
  onGetStarted
}) => {
  return (
    <div className="relative h-full w-full flex flex-col items-center justify-center text-primary">
      {/* Main content */}
      <div className="flex flex-col items-center justify-center flex-1">
        <h1 className="text-dls-h1 text-primary mb-spacing-4">You're ready.</h1>
        
        {/* Command key display - hidden on mobile 
        <div className="hidden md:flex items-center gap-spacing-3">
          <kbd className="flex items-center justify-center w-[48px] h-[48px] text-[24px] font-normal bg-bg-well border border-border-default rounded-lg text-primary">
            ⌘
          </kbd>
          <kbd className="flex items-center justify-center w-[48px] h-[48px] text-[24px] font-normal bg-bg-well border border-border-default rounded-lg text-primary">
            k
          </kbd>
        </div>
        */}
        
        {/* Mobile-friendly message and action */}
        <div className="text-center">
          <p className="text-dls-body text-secondary mb-spacing-4">Jump in to experience seamless model-switching and keyboard-driven productivity with Consl.</p>
          <button
            onClick={onGetStarted}
            className="h-[42px] px-spacing-6 bg-accent text-primary rounded-lg hover:bg-hover focus:outline-none focus-visible:ring-2 focus:ring-accent/50 transition-colors text-dls-body font-normal"
          >
            Experience Consl
          </button>
        </div>
      </div>
      
      {/* Navigation at bottom */}
      <div className="relative flex justify-center items-center pb-spacing-4 w-full">
        {renderProgress(progressProps)}
        
        <div className="w-full h-full absolute left-spacing-2">
          {renderNavigation(navigationProps)}
        </div>
      </div>
    </div>
  )
}

CommandInterface.propTypes = {
  renderNavigation: PropTypes.func.isRequired,
  renderProgress: PropTypes.func.isRequired,
  navigationProps: PropTypes.object.isRequired,
  progressProps: PropTypes.object.isRequired,
  onGetStarted: PropTypes.func
}

export default CommandInterface
